import React from 'react';
import { CancelOrderDialogWindows } from '../../../components/clientPortal/orderOverview/CancelOrderDialogWindows';
import { useAppDispatch } from '../../../store/store';
import { UUID } from '../../../types/shared/UUID';
import { eExternalOrderStatus } from '../../../ui-toolkit/enums/eExternalOrderStatus';
import { postClientOrderCancellationAction } from '../../../store/clientPortal/clientOrderCancellation/clientPostOrderCancellationSlice';
import { getClientOrderAction } from '../../../store/clientPortal/clientOrderSlice';

export const ClientCancelOrderContainer: React.FC<{
  orderId: UUID;
  orderStatus?: eExternalOrderStatus;
  setShowCancelOrderDialog: (showDialog: boolean) => void;
}> = ({ orderId, orderStatus, setShowCancelOrderDialog }) => {
  const dispatch = useAppDispatch();

  const onCancelOrder = async (reason: string) => {
    await dispatch(postClientOrderCancellationAction({ orderId, reason }));
    setShowCancelOrderDialog(false);
    dispatch(getClientOrderAction(orderId));
  };

  const onResetCancelOrder = () => {
    setShowCancelOrderDialog(false);
    window.location.reload();
  };

  return (
    <CancelOrderDialogWindows
      isOrderAutoCancelable={orderCannotBeAutoCanceledForStatuses.includes(orderStatus)}
      onClose={onResetCancelOrder}
      onCancelOrder={onCancelOrder}
    />
  );
};

const orderCannotBeAutoCanceledForStatuses: (eExternalOrderStatus | undefined)[] = [
  eExternalOrderStatus.signing_scheduled,
  eExternalOrderStatus.signing_confirmed,
  eExternalOrderStatus.signing_occurred,
  eExternalOrderStatus.waiting_for_funds,
  eExternalOrderStatus.funded,
  eExternalOrderStatus.funded_and_recorded,
  eExternalOrderStatus.policy_issued,
  eExternalOrderStatus.recorded,
];
